module.exports = __webpack_public_path__ + "img/float-btn-sports.f6beb9ef.svg";